var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWithName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.07,143.28c-1.79,0-3.25-1.47-3.25-3.28l-.03-88.92c0-1.82.71-3.51,2-4.74,1.22-1.16,2.87-1.83,4.53-1.83,1.36,0,2.67.44,3.8,1.27l79.66,58.33c1.99,1.46,2.99,3.88,2.6,6.33-.39,2.45-2.08,4.45-4.42,5.21l-83.89,27.47c-.33.11-.67.16-1.01.16Z",
    style: {
      fill: "#5bbec8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.21,235.56l51.9-71.97c1.3-1.8.48-4.36-1.63-5.05l-83.96-27.48c-5.06-1.66-9.84,3.17-8.2,8.27l30.43,94.4c1.64,5.1,8.33,6.17,11.46,1.83Z",
    style: {
      fill: "#83ca7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5,255.51c-2.46,0-4.68-1.37-5.8-3.58-1.12-2.21-.91-4.83.53-6.83l51.9-71.97c.61-.85,1.59-1.35,2.63-1.35s2.02.51,2.63,1.35l51.84,71.97c1.45,2.01,1.65,4.63.53,6.84-1.11,2.21-3.34,3.58-5.8,3.58h-98.47Z",
    style: {
      fill: "#fadd61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,238.26c-2.12,0-3.99-.96-5.24-2.71l-51.83-71.96c-.61-.85-.78-1.95-.46-2.94.32-.99,1.1-1.78,2.09-2.1l83.89-27.47c.67-.22,1.36-.33,2.04-.33,2.05,0,4.02,1.02,5.25,2.74,1.25,1.73,1.57,3.81.91,5.87l-30.43,94.38c-.88,2.71-3.37,4.54-6.21,4.54Z",
    style: {
      fill: "#a67dd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,143.28c-.34,0-.68-.05-1.01-.16l-83.96-27.48c-2.34-.77-4.03-2.76-4.42-5.22-.39-2.45.61-4.88,2.6-6.33l79.67-58.34c1.13-.83,2.45-1.26,3.8-1.26,3.6,0,6.53,2.95,6.53,6.57l.03,88.94c0,.9-.34,1.71-.98,2.34-.62.61-1.41.94-2.27.94Z",
    style: {
      fill: "#dd6f81"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1210.4,76l-14.18,10.31c-2.02,1.47-2.86,4.07-2.09,6.44l5.42,16.67c.77,2.37,2.98,3.98,5.48,3.98h17.53c2.5,0,4.71-1.61,5.48-3.98l5.42-16.67c.77-2.37-.07-4.97-2.09-6.44l-14.18-10.31c-2.02-1.47-4.75-1.47-6.77,0Z",
    style: {
      fill: "#38bdc8"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M412.75,131.59c-6.27-6.48-16.73-11.71-28.03-11.71-18.41,0-32.84,15.9-32.84,35.56s14.44,35.77,34.52,35.77c9.83,0,20.29-4.39,26.35-11.71l23.01,25.52c-11.29,13.59-28.24,20.71-51.66,20.71-39.53,0-69.24-31.58-69.24-70.28s31.17-70.07,69.45-70.07c24.26,0,40.79,7.95,51.45,19.87l-23.01,26.35Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.91,172.59c0-29.49,24.05-53.34,53.34-53.34s53.34,23.85,53.34,53.34-24.06,53.13-53.34,53.13-53.34-23.85-53.34-53.13ZM525.91,172.59c0-12.34-8.37-21.75-19.66-21.75s-19.66,9.41-19.66,21.75,8.37,21.54,19.66,21.54,19.66-9.41,19.66-21.54Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.97,222.58h-33.67v-100.19h33.67v14.01c5.02-10.46,14.22-17.15,26.77-17.15,14.22,0,25.31,6.9,31.17,19.03,5.65-10.25,14.02-19.03,29.91-19.03,23.22,0,38.49,15.48,38.49,43.51v59.82h-33.68v-55.22c0-10.04-5.86-16.52-14.64-16.52s-14.85,6.48-14.85,16.52v55.22h-33.67v-55.22c0-10.04-5.86-16.52-14.64-16.52s-14.85,6.48-14.85,16.52v55.22Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.55,172.38c0,30.75-20.08,53.34-47.48,53.34-11.09,0-19.66-4.18-25.52-11.5v8.37h-33.67V78.67h33.67v53.13c6.06-7.74,14.43-12.55,25.52-12.55,25.52,0,47.48,20.92,47.48,53.13ZM818.55,172.38c0,12.34,8.37,21.75,19.66,21.75s19.66-9.41,19.66-21.75-8.37-21.55-19.66-21.55-19.66,9.41-19.66,21.55Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.4,172.59c0-29.49,24.05-53.34,53.34-53.34s53.34,23.85,53.34,53.34-24.05,53.13-53.34,53.13-53.34-23.85-53.34-53.13ZM988.4,172.59c0-12.34-8.37-21.75-19.66-21.75s-19.66,9.41-19.66,21.75,8.36,21.54,19.66,21.54,19.66-9.41,19.66-21.54Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.83,88.5h34.51v50.83h9.83l31.38-50.83h38.49l-40.79,65.05,44.55,69.03h-41.62l-31.17-50.83h-10.67v50.83h-34.51V88.5Z",
    style: {
      fill: "#38bdc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.01,78.67v143.91h-33.67v-9.41c-6.06,7.74-14.43,12.55-25.52,12.55-25.52,0-47.48-20.91-47.48-53.13s20.08-53.34,47.48-53.34c11.09,0,19.66,4.18,25.52,11.5v-52.08h33.67ZM1333.33,172.59c0-12.34-8.37-21.75-19.66-21.75s-19.66,9.41-19.66,21.75,8.37,21.54,19.66,21.54,19.66-9.41,19.66-21.54Z",
    style: {
      fill: "#38bdc8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1196.95,
    y: 127.41,
    width: 33.67,
    height: 95.18,
    style: {
      fill: "#38bdc8"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithName);
export default __webpack_public_path__ + "static/media/logo_with_name.d9ac9f24aa95574413aa75513c48b88d.svg";
export { ForwardRef as ReactComponent };